import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { ToolbarService } from '@syncfusion/ej2-angular-grids';
import { LinkService, ImageService, HtmlEditorService, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { BsModalService } from 'ngx-bootstrap';

import { Observable } from "rxjs";
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
@Component({
  selector: 'app-under-the-hood-widget',
  templateUrl: './under-the-hood-widget.component.html',
  styleUrls: ['./under-the-hood-widget.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService,],
})
export class UnderTheHoodWidgetComponent implements OnInit, OnChanges {


  location: Location;

  @Output('toggleShow') toggleShow: EventEmitter<any> = new EventEmitter();
  
  @Input() brand_id: number;
  @Input() title: string = 'Upload or Select File';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;
  @Input() promotion_id: number;
  @Input() current_route: any;


       // setup as observable?
      //  @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'full'; // 

       @Input() varible_code_block_type_id? = ''; // Sets what content to show. default is PDF Vars / labels.
       @Input() template_model?: any; // send the subject communication model to set the search paremers for the variable code block grids choosers.
  nav: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: any;
  current_dynamic_route: any;
  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
  ) {
    this.nav = document.querySelector('nav.navbar');


    // login vars
    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

    // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
    this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    // Location
    this.location = location;

    let check_dynamic_route =  this.endsWithNumber(this.gfunc.router.url)
    if(check_dynamic_route == 'ends with a number'){
           // this.gfunc.router.url
           this.current_dynamic_route = this.gfunc.router.url.replace(/\d+$/, "")
      // remove the numbers to first back slash.
    }else{
      // Use the current route as is gloablly 
      this.current_dynamic_route = this.gfunc.router.url;
    }

    // see if last is a number of strimg....
    // strip all numbers at end pf strimg
    
    // set the route wthout the numbers so I can add card directluy as a route / wotjpit ods///

   }

  ngOnInit(): void {
  }


  ngOnChanges(changes): void  {
    this.current_route = changes.current_route.currentValue;
    // this.model = new AppRoute()
  
    // if current_route set and changes if this component is included 
    if (changes.current_route) {
      this.current_route = changes.current_route.currentValue;

 


    }
  }


// @ :: https://stackoverflow.com/questions/59124178/how-to-check-if-last-character-of-a-string-is-a-digit-number-by-the-fastest-way
  endsWithNumber(str){
    str = str.trim();
    if (!str) return 'Invalid input'; //return if input is empty
    return isNaN(str.slice(-1)) ? 'does NOT end with a number' : 'ends with a number';
  }


}
